import { createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { State } from './typings'
import { getCompanySetup } from './api'

export const initialState: State = {
  companySetup: {
    id: '',
    name: '',
    address: {
      address: '',
      address2: '',
      city: '',
      state: '',
      postalCode: '',
      latitude: 0,
      longitude: 0,
    },
    phone: '',
    email: '',
    timeZone: '',
  },
}

export const companySetup = createSlice({
  name: 'companySetup',
  initialState,
  reducers: {
    resetCompanySetup: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getCompanySetup.fulfilled, (state, { payload }) => {
      state.companySetup = { ...payload }
    })
  },
})

export const { resetCompanySetup } = companySetup.actions

export default companySetup.reducer

export const selectCompanyInfo = (state: StoreData) =>
  state.companySetup.companySetup
